export default __webpack_public_path__ + "static/media/shopping.ecdb8cfd.png";